import { h, defineComponent } from 'vue';
import { Button, ButtonProps } from '@/ui/components/Button';
import { t } from '@/ui/i18n/i18n';

export interface SubscribeButtonProps extends ButtonProps {
  planId: string;
  seats?: string | null;
  interval?: string | null;
  text?: string | null;
}

export const SubscribeButton = defineComponent<SubscribeButtonProps>({
  name: 'SubscribeButton',
  props: ['planId', 'seats', 'interval', 'type', 'btnClass', 'iconLeft', 'iconRight', 'iconPack', 'loading', 'tag', 'disabled', 'outlined', 'size', 'text'],
  setup(props, ctx) {
    return function render() {
      return h(Button,
        {
          props,
          nativeOn: {
            click: () => ctx.emit('checkout', {
              planId: props.planId,
              numberSeats: props.seats,
              interval: props.interval,
            }),
          },
        },
        [props.text ?? t('trial-end.professional-plan.proceed')]);
    };
  },
});
